import React, { useEffect, useRef, useState } from 'react';
import { account } from './copData';

const TITLES = {
	home: 'Home',
	'command-center': 'Command Center',
	clustering: 'Clustering Studio',
	builder: 'Campaign Builder',
	'experiment-lab': 'Experiment Lab',
	reporting: 'Intelligence Reporting',
	'deep-research': 'Deep Research',
	approvals: 'Approval Queue',
	'audit-log': 'Audit Log',
	suppressions: 'Global Suppressions',
	settings: 'Settings',
	help: 'Help & Concepts',
};

export default function CopTopbar({
	view,
	isInternal,
	autopilot,
	user,
	theme,
	onSetTheme,
	onNavigate,
	onMenuClick,
	reportDateRange,
	reportDateRangePresets = [],
	onSetReportPreset,
	onSetReportDate,
}) {
	const [menuOpen, setMenuOpen] = useState(false);
	const menuRef = useRef(null);

	const initials = (user?.name || 'J D')
		.split(' ')
		.map((p) => p[0])
		.slice(0, 2)
		.join('')
		.toUpperCase();

	useEffect(() => {
		if (!menuOpen) return undefined;
		const onClick = (e) => {
			if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
		};
		const onKey = (e) => e.key === 'Escape' && setMenuOpen(false);
		document.addEventListener('mousedown', onClick);
		document.addEventListener('keydown', onKey);
		return () => {
			document.removeEventListener('mousedown', onClick);
			document.removeEventListener('keydown', onKey);
		};
	}, [menuOpen]);

	return (
		<header className="cop-topbar">
			<button
				type="button"
				className="cop-menu-btn"
				onClick={onMenuClick}
				aria-label="Open navigation menu"
			>
				<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
					<line x1="3" y1="6" x2="21" y2="6" />
					<line x1="3" y1="12" x2="21" y2="12" />
					<line x1="3" y1="18" x2="21" y2="18" />
				</svg>
			</button>
			<span className="cop-crumb">
				{account.merchant_name} / <b>{TITLES[view] || 'Dashboard'}</b>
			</span>
			{reportDateRange && (
				<div className="cop-topbar-right">
					<div className="cop-date-range" aria-label="Reporting date range">
						<select
							value={reportDateRange.preset}
							onChange={(e) => onSetReportPreset(e.target.value)}
							aria-label="Reporting date preset"
						>
							{reportDateRangePresets.map((preset) => (
								<option key={preset.value} value={preset.value}>
									{preset.label}
								</option>
							))}
						</select>
						<label>
							<span>From</span>
							<input
								type="date"
								value={reportDateRange.startDate}
								max={reportDateRange.endDate}
								onChange={(e) => onSetReportDate('startDate', e.target.value)}
							/>
						</label>
						<label>
							<span>To</span>
							<input
								type="date"
								value={reportDateRange.endDate}
								min={reportDateRange.startDate}
								onChange={(e) => onSetReportDate('endDate', e.target.value)}
							/>
						</label>
					</div>
				</div>
			)}

			<div className="cop-user-menu" ref={menuRef}>
					<button
						className="cop-avatar"
						onClick={() => setMenuOpen((o) => !o)}
						aria-haspopup="menu"
						aria-expanded={menuOpen}
						title="Account & preferences"
					>
						{initials}
					</button>

					{menuOpen && (
						<div className="cop-dropdown" role="menu">
							<div className="cop-dd-user">
								<div className="cop-dd-name">{user?.name || 'Operator'}</div>
								<div className="cop-dd-email">{user?.email || ''}</div>
							</div>

							<div className="cop-dd-label">Theme</div>
							<div className="cop-theme-seg" role="group" aria-label="Theme">
								<button className={theme === 'dark' ? 'active' : ''} onClick={() => onSetTheme('dark')}>
									◐ Dark
								</button>
								<button className={theme === 'light' ? 'active' : ''} onClick={() => onSetTheme('light')}>
									○ Light
								</button>
							</div>

							<button
								className="cop-dd-row"
								onClick={() => {
									setMenuOpen(false);
									onNavigate('settings');
								}}
							>
								⚙ Settings
							</button>
							<button
								className="cop-dd-row"
								onClick={() => {
									setMenuOpen(false);
									onNavigate('help');
								}}
							>
								? Help &amp; Concepts
							</button>
						</div>
					)}
			</div>
		</header>
	);
}
